import { useQuery } from '@tanstack/react-query'
import { statistikApi } from '../lib/client'
import { ApiResponse, StatistikPendidikan } from '../../../shared-lib/types'

export function usePendidikanStats() {
    return useQuery<ApiResponse<StatistikPendidikan>>({
        queryKey: ['statistik', 'pendidikan'],
        queryFn: async () => {
            try {
                return await statistikApi.getPendidikan()
            } catch (error) {
                const errorResponse: ApiResponse<StatistikPendidikan> = {
                    status: "error",
                    message: error instanceof Error ? error.message : "Gagal mengambil data statistik pendidikan",
                    data: {
                        totalPenduduk: 0,
                        pendidikan: []
                    }
                }
                
                console.error('Error fetching pendidikan statistics:', error)
                throw errorResponse
            }
        },
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 3,
    })
}
